import React from "react";
import SignIn from "./components/SignIn";
const SignInView = () => {
  return (
    <div>
      <SignIn />
    </div>
  );
};

export default SignInView;
